import styled from '@emotion/styled';
import Close from '~/icons/close.svg';
import LogoPlus from '~/icons/logo-plus.svg';
import Button, { StyledButton } from '../../shared/components/Button';
import { LoginDrawerMode } from './hooks/useLoginDrawerState';
import { theme } from '~/theme';

export const Content = styled.div({
    height: '100%',
});

export const Container = styled.div(() => ({
    '> *': {
        marginTop: theme.space[3],
    },

    '>:first-child': {
        marginTop: theme.space[3],
    },
}));

export const StyledHeader = styled.div(() => ({
    height: `${theme.metrics.xlarge}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: `0 2px 20px 0 rgba(0,0,0,0.2)`,
    padding: '10px',
}));

export const StyledTitle = styled.p(() => ({
    display: 'flex',
    height: `${theme.metrics.xlarge}`,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    ...theme.mixins.useTextStyle('InfoHeader'),
}));

export const CloseButton = styled(Button)(() => ({
    svg: {
        height: `${theme.fontSizes.sm}`,
        width: `${theme.fontSizes.sm}`,
    },
}));
export const StyledClose = styled(Close)({});

export const StyledCTAButton = styled(StyledButton)(() => ({
    width: '100%',
    height: `${theme.metrics.medium}`,
    marginTop: '16px',
}));

export const StyledForgotPasswordLink = styled.a(() => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
    fontWeight: theme.fontWeights.medium,
    textDecoration: 'underline',
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledH4 = styled.h4(() => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['xl'],
}));
export const StyledLoginTextblock = styled.p(() => ({
    marginBottom: '20px',
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
}));
export const StyledLoginSignupWrapper = styled.div<{
    loginDrawerMode: LoginDrawerMode;
}>(({ theme, loginDrawerMode }) => ({
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '50px',
    alignItems: 'end',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: theme.space[3],
    borderBottom: `1px solid #D6D6D6`,
    marginBottom: theme.space[4],

    '::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: '1px',
        width: '50%',
        backgroundColor: theme.colors.black,
        transition: 'transform 0.3s ease',
        transform:
            loginDrawerMode === LoginDrawerMode.SIGN_UP ||
            loginDrawerMode === LoginDrawerMode.CREATE_LOGIN
                ? 'translateX(100%)'
                : 'translateX(0)',
    },
}));

export const StyledLoginButton = styled.div<{
    loginDrawerMode: LoginDrawerMode;
}>(({ theme, loginDrawerMode }) => ({
    width: '100%',
    color: theme.colors.black,
    cursor: 'pointer',
    textAlign: 'center',
    fontWeight:
        loginDrawerMode === LoginDrawerMode.LOGIN
            ? theme.fontWeights.bold
            : theme.fontWeights.medium,
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledSignupButton = styled.div<{
    loginDrawerMode: LoginDrawerMode;
}>(({ theme, loginDrawerMode }) => ({
    width: '100%',
    color: theme.colors.black,
    textAlign: 'center',
    cursor: 'pointer',
    fontWeight:
        loginDrawerMode === LoginDrawerMode.SIGN_UP
            ? theme.fontWeights.bold
            : theme.fontWeights.medium,
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const CheckboxLabel = styled.span(() => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
}));

export const StyledImercoPlusWrapper = styled.div(() => ({
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.space[3],
    marginBottom: theme.space[6],
}));

export const StyledLogo = styled(LogoPlus)(() => ({
    display: 'flex',
    height: theme.space[5],
    width: '100%',
    marginBottom: theme.space[3],
}));

export const StyledMiddleContent = styled.div(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${theme.space[6]} 0`,
    alignItems: 'center',
}));

export const StyledSpacer = styled.div(() => ({
    margin: `${theme.space[6]} 0`,
    '> *:not(:last-child)': {
        marginBottom: theme.space[3],
    },
}));

export const StyledInputTitle = styled.div(() => ({
    fontSize: theme.fontSizes['xs'],
    fontWeight: theme.fontWeights.medium,
}));

export const StyledReadMore = styled.div(() => ({
    fontSize: theme.fontSizes['2xs'],
    fontWeight: theme.fontWeights.regular,
    marginBottom: theme.space[2],
}));

export const StyledInputWrapper = styled.div(() => ({
    display: 'flex',
    alignItems: 'center',
    paddingRight: '30px',
}));

export const StyledLinkText = styled.span(() => ({
    textDecoration: 'underline',
    fontWeight: theme.fontWeights.medium,
}));

export const StyledInputText = styled.span(() => ({
    fontSize: theme.fontSizes['xs'],
}));

export const StyledBirthDayText = styled.span(() => ({
    ...theme.mixins.useTextStyle('xs'),
    color: theme.colors.black,
    marginLeft: theme.space[2],
}));
